import ar from './locale/ar';
import bg from './locale/bg';
import ca from './locale/ca';
import cs from './locale/cs';
import da from './locale/da';
import de from './locale/de';
import el from './locale/el';
import en from './locale/en';
import es from './locale/es';
import et from './locale/et';
import fa from './locale/fa';
import fi from './locale/fi';
import fr from './locale/fr';
import he from './locale/he';
import hi from './locale/hi';
import hu from './locale/hu';
import id from './locale/id';
import it from './locale/it';
import ja from './locale/ja';
import ko from './locale/ko';
import lv from './locale/lv';
import ml from './locale/ml';
import nl from './locale/nl';
import no from './locale/no';
import pl from './locale/pl';
import pt from './locale/pt';
import pt_BR from './locale/pt_BR';
import ro from './locale/ro';
import ru from './locale/ru';
import sk from './locale/sk';
import sr from './locale/sr';
import sv from './locale/sv';
import ta from './locale/ta';
import th from './locale/th';
import tr from './locale/tr';
import uk from './locale/uk';
import uz from './locale/uz';
import vi from './locale/vi';
import zh_CN from './locale/zh_CN';
import zh_TW from './locale/zh_TW';
import is from './locale/is';
import lt from './locale/lt';

const locales = {
  ar,
  bg,
  ca,
  cs,
  da,
  de,
  el,
  en,
  es,
  et,
  fa,
  fi,
  fr,
  he,
  hi,
  hu,
  id,
  it,
  ja,
  ko,
  ml,
  lv,
  nl,
  no,
  pl,
  pt_BR,
  pt,
  ro,
  ru,
  sk,
  sr,
  sv,
  ta,
  th,
  tr,
  uk,
  uz,
  vi,
  zh_CN,
  zh_TW,
  is,
  lt,
};

// Yep! — substitui "Chatwoot" pelo nome da instalacao em TODAS as strings de
// TODOS os idiomas, num ponto unico. A alternativa seria editar ~78 strings
// espalhadas pelos arquivos de traducao, com custo de merge muito maior.
// O `useBranding` do upstream faz isso, mas so em 10 componentes.
// Ver CUSTOMIZACOES.md.
const BRAND_NAME =
  (typeof window !== 'undefined' &&
    window.globalConfig &&
    window.globalConfig.INSTALLATION_NAME) ||
  'Yep! Chat Commerce';

// **Nunca troca dentro de `{...}`.** O nome do parametro faz parte da sintaxe do
// vue-i18n, nao do texto: trocar `{latestChatwootVersion}` por
// `{latestYep! Chat CommerceVersion}` faz o compilador de mensagem estourar
// ("Unterminated closing brace") e a string inteira renderizar **vazia**.
//
// Aconteceu de verdade: o banner de "nova versao disponivel" aparecia sem
// texto nenhum, so com o link. Nenhum erro na tela, nenhum log — a familia de
// bug que mais custou tempo neste projeto.
//
// Hoje ha exatamente um parametro assim em 57 idiomas
// (`{latestChatwootVersion}`), mas a guarda fica: o proximo merge com o
// upstream pode trazer outro, e o sintoma seria o mesmo silencio.
const PLACEHOLDER = /\{[^{}]*\}/g;

const trocaForaDoPlaceholder = texto => {
  let saida = '';
  let cursor = 0;
  texto.replace(PLACEHOLDER, (achado, posicao) => {
    saida += texto.slice(cursor, posicao).replace(/Chatwoot/g, BRAND_NAME);
    saida += achado;
    cursor = posicao + achado.length;
    return achado;
  });
  return saida + texto.slice(cursor).replace(/Chatwoot/g, BRAND_NAME);
};

const rebrand = value => {
  if (typeof value === 'string') return trocaForaDoPlaceholder(value);
  if (Array.isArray(value)) return value.map(rebrand);
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, val]) => [key, rebrand(val)])
    );
  }
  return value;
};

export default rebrand(locales);
